import Vue from 'vue'

import GuideButton from '@/components/GuideButton'
import Carousel from '@/components/Carousel'
import NavLink from '@/components/NavLink'
import MiniMap from '@/components/MiniMap'
import BgVideo from '@/components/BgVideo'
import Left from '@/components/Left'
import Right from '@/components/Right'
import NavBar from '@/components/NavBar'
import Dot from '@/components/Dot'
import MaxCard from '@/components/MaxCard'
import DPlayer from '@/components/DPlayer'
import LoopPic from '@/components/LoopPic'

Vue.component(GuideButton.name, GuideButton)
Vue.component(Carousel.name, Carousel)
Vue.component(NavLink.name, NavLink)
Vue.component(MiniMap.name, MiniMap)
Vue.component(BgVideo.name, BgVideo)
Vue.component(Left.name, Left)
Vue.component(Right.name, Right)
Vue.component(NavBar.name, NavBar)
Vue.component(LoopPic.name, LoopPic)
Vue.component(DPlayer.name, DPlayer)
Vue.component(MaxCard.name, MaxCard)
Vue.component(Dot.name, Dot)
import VPlayer from '@/utils/VPlayer'
import Narrate from '@/utils/Narrate'
import showFrame from '@/utils/frame'
import showImages from '@/utils/showImages'

Vue.prototype.$vplayer = VPlayer
Vue.prototype.$narrate = Narrate
Vue.prototype.$showFrame = showFrame
Vue.prototype.$showImages = showImages
Vue.prototype.$bgAudio = document.createElement('AUDIO')
Vue.prototype.$bgAudio.src = require('./assets/audio/bg.mp3')
